import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Printer, Smartphone } from 'lucide-react';
import { Button } from './Button';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="pt-16 pb-20 px-6 md:px-12 lg:px-24 bg-cream" data-id="element-89">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-90">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="space-y-8" data-id="element-91">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-navy leading-tight" data-id="element-92">
            ¿Qué pasaría con tus fotos, recuerdos y cuentas si mañana no
            pudieras acceder a ellas?
          </h1>

          <p className="text-xl md:text-2xl text-navy-light leading-relaxed" data-id="element-93">
            Protege tu historia familiar y asegura tu tranquilidad con el{' '}
            <strong className="text-navy" data-id="element-94">Método "Zero-Tech"</strong>. Una guía
            paso a paso diseñada para organizar tu legado digital sin
            complicaciones técnicas.
          </p>

          <div className="pt-4" data-id="element-95">
            <Button onClick={scrollToPricing} fullWidth className="max-w-md" data-id="element-96">
              Empieza Mi Legado Digital <span className="ml-2" data-id="element-97">→</span>
            </Button>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 pt-4 text-navy-light font-medium" data-id="element-98">
            <div className="flex items-center gap-2" data-id="element-99">
              <ShieldCheck className="text-gold w-6 h-6" data-id="element-100" />
              <span data-id="element-101">Descarga Inmediata</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-102">
              <Printer className="text-gold w-6 h-6" data-id="element-103" />
              <span data-id="element-104">100% Imprimible</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-105">
              <Smartphone className="text-gold w-6 h-6" data-id="element-106" />
              <span data-id="element-107">Sin apps complicadas</span>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative" data-id="element-108">
          <div className="absolute inset-0 bg-gold/20 rounded-3xl transform translate-x-4 translate-y-4" data-id="element-109"></div>
          <img src="https://cdn.magicpatterns.com/uploads/arBS19sAwJZDU9GRzbcGvs/iPad_Foto.png" alt="Legado Digital Seguro en iPad" className="relative z-10 w-full h-auto rounded-3xl shadow-2xl object-cover" data-id="element-110" />
        </motion.div>
      </div>
    </section>;
}